import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const LOGO_DARK = "https://customer-assets.emergentagent.com/job_precision-connect/artifacts/lvo1u53w_image.png";

const navLinks = [
  { label: 'Protocolo', href: '/protocolo', isRoute: true },
  { label: 'Empresas', href: '/empresa', isRoute: true },
  { label: 'Advisors', href: '/advisor', isRoute: true },
];

export default function Header({ variant = 'landing' }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isLanding = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNav = (link) => {
    setMobileOpen(false);
    if (link.isRoute) {
      navigate(link.href);
    } else {
      const el = document.querySelector(link.href);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleCTA = () => {
    setMobileOpen(false);
    navigate('/empresa');
  };

  const handleLogoClick = (e) => {
    e.preventDefault();
    if (isLanding) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
    }
  };

  const isSolid = variant === 'subpage' || scrolled;

  return (
    <header
      data-testid="main-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isSolid ? 'header-glass shadow-lg shadow-black/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <a
          href="/"
          onClick={handleLogoClick}
          data-testid="header-logo"
          className="flex items-center"
        >
          <img src={LOGO_DARK} alt="Conadvy" className="h-[68px] md:h-[76px] object-contain" />
        </a>

        <nav className="hidden md:flex items-center gap-10" data-testid="desktop-nav">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNav(link)}
              data-testid={`nav-${link.href.replace('/', '').replace('/', '-')}`}
              className="text-white/70 hover:text-white text-sm tracking-wide transition-colors duration-300"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={handleCTA}
            data-testid="header-cta"
            className="bg-[#C58C40] text-white hover:bg-[#b07b35] transition-colors duration-300 rounded-sm px-6 py-2.5 text-xs tracking-[0.15em] uppercase"
          >
            Iniciar Mandato
          </button>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white p-2"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {mobileOpen && (
        <div data-testid="mobile-menu" className="md:hidden header-glass border-t border-white/10">
          <div className="px-6 py-6 flex flex-col gap-5">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => handleNav(link)}
                data-testid={`mobile-nav-${link.href.replace('/', '').replace('/', '-')}`}
                className="text-white/70 hover:text-white text-sm tracking-wide text-left transition-colors"
              >
                {link.label}
              </button>
            ))}
            <button
              onClick={handleCTA}
              data-testid="mobile-header-cta"
              className="bg-[#C58C40] text-white hover:bg-[#b07b35] rounded-sm px-6 py-3 text-xs tracking-[0.15em] uppercase mt-2"
            >
              Iniciar Mandato
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
